module.exports = __webpack_public_path__ + "img/forgot-password.674fe9ba.png";